import { InMemoryCache, ErrorPolicy, FetchPolicy } from '@apollo/client';
import _merge from 'lodash/merge';
import { Alert } from '@blocs.common';
import createProfileEditUploadedPhotoResolvers, {
  initializeCreateProfileUploadedPhotoState,
} from 'lib/ApolloLinkState/createProfileEditUploadedPhoto';
import editProfileResolvers, { initializeUpdatedProfileFieldState } from 'lib/ApolloLinkState/editProfile';
import editUploadedPhotoResolvers, { initializeUploadedPhotoDataState } from 'lib/ApolloLinkState/editUploadedPhoto';
import loginResolvers, { initializeLoginState } from 'lib/ApolloLinkState/login';

// use this after instantiating the cache to initialize the cache
// for client-only state
export const INIT_CACHE_STATE = (inMemCache: InMemoryCache): void => {
  initializeCreateProfileUploadedPhotoState(inMemCache);
  initializeUpdatedProfileFieldState(inMemCache);
  initializeUploadedPhotoDataState(inMemCache);
  initializeLoginState(inMemCache);
  Alert.initializeAlertState(inMemCache);
};

export const RESOLVERS = () =>
  _merge(
    createProfileEditUploadedPhotoResolvers.resolvers,
    editProfileResolvers.resolvers,
    editUploadedPhotoResolvers.resolvers,
    loginResolvers.resolvers,
    Alert.globalAlertResolvers
  );

export const DEFAULT_OPTIONS = () => ({
  query: {
    fetchPolicy: 'cache-and-network' as FetchPolicy,
    errorPolicy: 'all' as ErrorPolicy,
  },
  mutate: {
    errorPolicy: 'all' as ErrorPolicy,
  },
});

// spread this into the ApolloClient config
export const BASE_CONFIG = () => ({
  resolvers: RESOLVERS(),
  defaultOptions: DEFAULT_OPTIONS(),
});
